export default __webpack_public_path__ + "static/media/lock.1aa05846.svg";